function validateUidCharSafe(value, componentName) {
  if (/\s/.test(value)) {
    // eslint-disable-next-line no-console
    console.warn(`Value of '${value}' supplied to '${componentName}' should be a string containing no space characters.`);
  }
  if (!/^[A-Za-z0-9:\-%]{3,}$/.test(value)) {
    // eslint-disable-next-line no-console
    console.warn(`Value of '${value}' supplied to '${componentName}' should be a string consisting of characters 'a-z', 'A-Z', '0-9' , '%' , '-' and be at least 3 characters long.`);
  }
  return value;
}

export { validateUidCharSafe as v };
//# sourceMappingURL=validateUidCharSafe-fddCu4jj.js.map
